import React, { useEffect, useState, PureComponent } from 'react';
import { useNavigate } from 'react-router-dom';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//datefomatter
import { format } from 'date-fns';
//chart
import { Cell, Pie, PieChart, ResponsiveContainer, Legend } from 'recharts';
//storestore
import useComnStore from 'src/webapp/stores/comn.store';
import usePartnerStore from 'src/webapp/stores/partner.store';
//style
import styles from 'src/asset/scss/style/dashboard.module.scss'

export default function DonutChart(props) {
    const { startDate, endDate } = props;//props
    const navigator = useNavigate();//navigator
    const { axiosPostHandler } = useAxiosHook();//axios
    const { socket } = useComnStore();
    const { isState, partner } = usePartnerStore();

    /* =============== 기간별 매출통계 =============== */
    const [ donutData,setDonutData ] = useState([]);
    const donutChartAPI = async() => {
    const DATA = { PARTNER_CD:partner.COMN_CD, START_DATE:format(startDate, 'yyyyMMdd'), END_DATE:format(endDate, 'yyyyMMdd') };
    const result = await axiosPostHandler(`partnerDonutChartForPartner.do`, DATA);
    if(!result || result.message !== "SUCCESS") { return; }
    if(result.message === "SUCCESS") {
        setDonutData(result.data);
    }
    }
    useEffect(() => {(async () => {
        if(!isState) { return; }
    
        donutChartAPI();
    })()}, [isState, startDate, endDate, socket]);
    /* =============== 기간별 매출통계 =============== */

    /* =============== 차트 컬러배열 =============== */
    const COLORS = ['#FFE248', '#705E00', '#737373', '#373737'];//컬러배열
    /* =============== 차트 컬러배열 =============== */
    /* =============== 차트 value 텍스트위치선정 =============== */
    const RADIAN = Math.PI / 180;
    const renderLabelPosition = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        if(donutData === undefined || donutData.length <= 0) { return null; }
        if(donutData[index].value === 0) { return null; }

        const radius = innerRadius + (outerRadius - innerRadius) * 0.4;
        const x = cx + (radius - 10) * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        return (
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">{`${(percent * 100).toFixed(0)}%`}</text>
        );
    };
    /* =============== 차트 value 텍스트위치선정 =============== */
    /* =============== 차트 카테고리 =============== */
    const categoryFilter = (idx) => {
        switch(idx) {
            case 0 : return "엔진오일";
            case 1 : return "타이어";
            case 2 : return "정기점검";
            case 3 : return "기타";
            case 4 : return "총";
        }
    }
    /* =============== 차트 카테고리 =============== */
    /* =============== 전체카테고리 합산 =============== */
    const totCount = donutData.reduce(function add(sum, currValue) {
        return sum + parseInt(currValue.value);
    }, 0);
    /* =============== 전체카테고리 합산 =============== */

    class MemberVehicleRankingPieChart extends PureComponent {
        render() {
        return (
            <>
            <div className={[styles.chartContainer, styles.donutChartContainer].join(" ")}>
                <h1><span>카테고리별 예약비율</span></h1>
                <div>
                    <ResponsiveContainer width="100%" height="100%" isAnimationActive={false}>
                        <PieChart width={224} height={224}>
                            <Pie cx="50%" cy="50%" data={donutData} stroke="none"
                                labelLine={false} label={renderLabelPosition}
                                innerRadius={30} outerRadius={80}
                                fill="#FF0000" dataKey="value">
                                {donutData.map((entry, i) => (
                                    <Cell key={`cell-${i}`} fill={COLORS[i % COLORS.length]} />
                                ))}
                            </Pie>
                            <Legend layout="vertical" align="right" verticalAlign="middle" fontSize={12} />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div>
            <div className={styles.categoryLogContainer}>
                <h1><span>예약현황</span></h1>
                <ul>
                    {donutData.map((item, idx) => (
                        <li key={idx}><label>{categoryFilter(idx)}</label><label>{item.cnt}건</label></li>
                    ))}  
                    <li><span>{categoryFilter(4)}</span><span>{totCount}건</span></li>
                </ul>
            </div>
            <div className={styles.buttonContainer}>
                <ul>
                    <li onClick={(e) => navigator(`/schedule`)}><small>예약내역</small><small><FontAwesomeIcon icon="fa-light fa-chevron-right" /></small></li>
                    <li onClick={(e) => navigator(`/notify`)}><small>알림</small><small><FontAwesomeIcon icon="fa-light fa-chevron-right" /></small></li>
                </ul>
            </div>
            </>
        )}
    } return ( <MemberVehicleRankingPieChart /> )
}